import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {RiskfactorClasses, RiskfactorInfo, RiskfactorSubject, RiskfactorscoreDegreeWithIncrease} from '../../model';
import {ActivatedRoute, Router} from "@angular/router";
import {Utils} from "@amlCore/utils";
import {RegistriesService} from "../../service";
import {DictionaryService, ValidatorService, UserService} from "@amlCore/services";
import {AlertPanelComponent, AlertPanelService, AlertService, BigSelectComponent, ICustomSelectMapper} from "@amlCore/components";
import {FormBuilder, FormGroup} from "@angular/forms";
import {JsonEditorComponent, JsonEditorOptions} from 'ang-jsoneditor';
import {IDataResponse, IDictItemType, IDictCountryItemType, IDictItemResultMap} from '@amlCore/interfaces';
import {Subject} from "rxjs";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmComponent } from 'src/app/core';
import {ICheckBoxValueType} from "../../../core/interfaces/ICheckBoxValueType";

@Component({
  selector: 'app-registry-riskfactor-country',
  templateUrl: './riskfactorCountry.component.html'
})

export class RiskfactorCountryComponent implements OnInit, OnDestroy {

  @ViewChild('alertObjSave') alertObjToSave: AlertPanelComponent;
  @ViewChild('jsonEditor', {static: true}) editor: JsonEditorComponent;
  @ViewChild('okved') okved: BigSelectComponent;
  @ViewChild('okved2') okved2: BigSelectComponent;
  @ViewChild('country') country: BigSelectComponent;
  okvedMapper: ICustomSelectMapper;
  countryMapper: ICustomSelectMapper;
  riskfactorClasses: RiskfactorClasses[];
  public scoreDegree: RiskfactorscoreDegreeWithIncrease[];
  public scoreEncrease: RiskfactorscoreDegreeWithIncrease[] = [];
  okvedData = [];
  okved2Data = [];
  countryData = [];
  id: string;
  formGroup: FormGroup;
  currentClassName: string;
  jsonEditorOption = new JsonEditorOptions();
  property: any = {};
  isReadOnlyAccess = this.userSrv.getAccess('risk_config').readOnly;
  public selectedDegree = 1;
  public selectedIncrease = 0;
  public scoreResult: number | string = 1;
  subjects: RiskfactorSubject[] = [
    {
      "id": "svedClient",
      "name": "Клиент",
      "checked": false
    },
    {
      "id": "svedAU",
      "name": "Учредители/участники",
      "checked": false
    },
    {
      "id": "svedIOU",
      "name": "Исполнительные органы управления",
      "checked": false
    },
    {
      "id": "svedPredst",
      "name": "Представители",
      "checked": false
    },
    {
      "id": "svedVPR",
      "name": "Выгодоприобретатели",
      "checked": false
    },
    {
      "id": "svedBV",
      "name": "Бенефициарные владельцы",
      "checked": false
    }
  ];
  pdlTypes: ICheckBoxValueType[] = [
    {
      "code": "1",
      "name": "ИПДЛ",
      "checked": false
    },
    {
      "code": "3",
      "name": "РПДЛ",
      "checked": false
    },
    {
      "code": "5",
      "name": "МПДЛ",
      "checked": false
    }
  ];
  typesDict: IDictItemResultMap[];
  levelsDict: IDictItemResultMap[];
  oksmDict: IDictCountryItemType[];
  okvedDict: IDictItemType[];
  okved2Dict: IDictItemType[];
  submitted = false;
  whereOpenUrl: string;
  $destroy = new Subject();
  constructor(private readonly regSrv: RegistriesService,
              private readonly route: ActivatedRoute,
              private readonly userSrv: UserService,
              protected readonly router: Router,
              protected readonly alertPanelSrv: AlertPanelService,
              protected readonly dictSrv: DictionaryService,
              private readonly validationSrv: ValidatorService,
              private readonly formBuilder: FormBuilder,
              private readonly activatedRoute: ActivatedRoute,
              private modalService: NgbModal) {
  }

  ngOnInit() {
    this.jsonEditorOption.mode = 'code';
    this.jsonEditorOption.modes = ['code', 'text'];
    this.jsonEditorOption.enableSort = false;
    this.jsonEditorOption.enableTransform = false;
    this.okvedMapper = {
      toModel: this.okvedMapperToModel.bind(this)
    } as ICustomSelectMapper;

    this.countryMapper = {
      toModel: this.countryMapperToModel.bind(this)
    } as ICustomSelectMapper;
    this._loadData();
    this._initForm();
    this._setForm();
    this._checkAccessUser();
    this.activatedRoute.params.subscribe(data => {
      if (data.whereOpenUrl) {
        this.whereOpenUrl = data.whereOpenUrl;
      }
    });
    setTimeout(() => {this.selectScoreDegree(this.selectedDegree, true);}, 1500);
  }

  goBack() {
    if (this.formGroup.dirty) {
      return new Promise<boolean>(resolve => {
        const modal = this.modalService.open(ConfirmComponent);
        modal.componentInstance.text = "Вы точно хотите выйти? Не все данные сохранены!";
        modal.componentInstance.isOutputText = false;
        modal.result.then(() => {
          if (history.length === 1) {
            const url = this.whereOpenUrl.indexOf('checkForm') ? '/cabinet/dossier/check' : this.whereOpenUrl;
            this.router.navigateByUrl(url)
            return;
          }
          history.back();
          resolve(true);
        }, () => {
          resolve(false);
        })
      });
    } else {
      if (history.length === 1) {
        const url = this.whereOpenUrl.indexOf('checkForm') ? '/cabinet/dossier/check' : this.whereOpenUrl;
        this.router.navigateByUrl(url)
        return;
      }
      history.back();
    }
  }

  ngOnDestroy(): void {
    this.$destroy.next();
    this.$destroy.complete();
  }

  okvedMapperToModel(origin: IDictItemType, isDictData: boolean): IDictItemType {
    if (isDictData) {
      return {
        code: origin.code,
        name: origin.name
      };
    } else {
      return origin;
    }
  }

  countryMapperToModel(origin: IDictCountryItemType, isDictData: boolean): IDictCountryItemType {
    if (isDictData) {
      return {
        kod: origin.kod,
        name: origin.name
      };
    } else {
      return origin;
    }
  }

  save(): void {
    this.submitted = true;
    if (this.formGroup.invalid) {
      this.alertObjToSave.open(this.alertPanelSrv.getErrorMsg('Не все поля заполнены корректно'));
      return;
    }
    if(this.isPdlClass()){
      this.saveTypePdl();
      if(!(this.property?.condition?.length > 0)) {
        this.alertObjToSave.open(
          this.alertPanelSrv.getErrorMsg('Не выбраны параметры контроля по типам субъектам. Сохранение невозможно.'));
        return;
      }
    }
    const dataForSave = this.formGroup.value as RiskfactorInfo;
    // При ручном вводе не передаем данные по конфигурации
    dataForSave.property = JSON.stringify(this.property);
    dataForSave.subjects = this.subjects;

    if (dataForSave.scoreDegree) {
      if (dataForSave.scoreDegree['id'] === undefined) {
        dataForSave.scoreDegree = {id: dataForSave.scoreDegree};
      }

      if (dataForSave.scoreIncrease) {
        if (dataForSave.scoreIncrease['id'] === undefined) {
          dataForSave.scoreIncrease = {id: dataForSave.scoreIncrease};
        }
      } else {
        dataForSave.scoreIncrease = {id: 0};
      }
    }
    this.regSrv.saveRiskfactorInfo(this.id, dataForSave).subscribe((data: RiskfactorInfo) => {
      if (!this.id) {
        this.id = data.id;
      }
      if (data.property) {
        this.property = JSON.parse(data.property);
      }
      this.alertObjToSave.open(this.alertPanelSrv.getSuccessMsg('Данные сохранены'));
      this.submitted = false;
      this.formGroup.markAsPristine();
    });
  }

  isShowCountryBtn(): boolean {
    return (this.currentClassName || []).indexOf('CheckCountry.class') > 0;
  }

  isShowOkvedBtn(): boolean {
    return (this.currentClassName || []).indexOf('CheckOkved.class') > 0;
  }

  isPdlClass(): boolean {
    return (this.currentClassName || []).indexOf('CheckPDL') > 0;
  }

  isPdlRClass(): boolean {
    return (this.currentClassName || []).indexOf('CheckPDLR.class') > 0;
  }

  closeModalOkved(state: boolean): void {
    if (state && this.property) {
      const currentProperty = Utils.clone(this.property)
       const newObj = {
        okved: this.okvedData.map(item => item.code),
        okved2: currentProperty.okved2
      };
      this.property = newObj;
    }
  }

  closeModalOkved2(state: boolean): void {
    if (state && this.property) {
      const currentProperty = Utils.clone(this.property)
       const newObj = {
        okved: currentProperty.okved,
        okved2: this.okved2Data.map(item => item.code),
      };
      this.property = newObj;
    }
  }

  closeModalCountry(state: boolean): void {
    if (state && this.property) {
      const _countries = this.countryData.map((item) => {
        return { code: item.kod };
      });
      const newObj = {
        countries: _countries
      };
      this.property = newObj;
    }
  }

  initModelOkved(): void {
    if (this.property && this.property?.okved?.length > 0) {
      const selectedOkvedList = [];
      this.property.okved.forEach((code: string) => {
        const selectedItem = this.okvedDict.find((item) => item.code === code);
        if (selectedItem) {
          selectedOkvedList.push(selectedItem);
        }
      });
      this.okvedData = selectedOkvedList;
    }
  }

  initModelOkved2(): void {
    if (this.property && this.property?.okved2?.length > 0) {
      const selectedOkved2List = [];
      this.property.okved2.forEach((code: string) => {
        const selectedItem = this.okved2Dict.find((item) => item.code === code);
        if (selectedItem) {
          selectedOkved2List.push(selectedItem);
        }
      });
      this.okved2Data = selectedOkved2List;
    }
  }

  initModelCountry(): void {
    if (this.property && this.property?.countries?.length > 0) {
      const selectedCountriesList = [];
      this.property.countries.forEach((currentItem: {code: string}) => {
        const selectedItem = this.oksmDict.find((itemDict) => itemDict.kod === currentItem.code);
        if (selectedItem) {
          selectedCountriesList.push({kod: selectedItem.kod, name: selectedItem.name});
        }
      });
      this.countryData = selectedCountriesList;
    }
  }

  private saveTypePdl(): void {
    this.property = {
      condition: []
    };
    const isRelative = this.isPdlRClass();
    this.pdlTypes.filter(pdlType => pdlType.checked).forEach(pdlType => {
     this.property.condition.push({
        "publicInfo.prv" :"1",
        "publicInfo.characterPDL.code": isRelative ? String( + pdlType.code + 1) : pdlType.code
      });
    });
  }

  syncEditorModelWithExternalModel(): void {
    if (this.property && this.property.hasOwnProperty('okved2') && this.property.okved2.length > 0) {
      this.initModelOkved();
    }

    if (this.property && this.property.hasOwnProperty('okved') && this.property.okved.length > 0) {
      this.initModelOkved2();
    }

    if (this.property && this.property.hasOwnProperty('countries') && this.property.countries.length > 0) {
      this.initModelCountry();
    }
  }

  /**
   * загрузка данных
   */
  private _loadData(): void {
    this.id = this.route.snapshot.params.id;
    const queryParams = {
      dir: "DESC",
      page: 0,
      size: 200,
      sort: "name",
      filter: {
        type: "DOSSIER"
      }
    };

    this.regSrv.getRiskfactorClasses(queryParams).subscribe((data: IDataResponse<RiskfactorClasses>) => {
      this.riskfactorClasses = data.content;
    });

    this.regSrv.getscoreDegreeWithIncreases().subscribe((data) => {
      this.scoreDegree = data;
      const select = this.scoreDegree?.filter(item => item.id === this.selectedDegree);
      this.scoreEncrease = select[0].scoreIncrease;
      if (select) {
        this.scoreEncrease = select[0]?.scoreIncrease;
      }
    });

    this.dictSrv.getRemoteData('risktype').then((result: IDictItemType[]) => {
      this.typesDict = result.map((item) => {
        return {id: item.code, name: item.name};
      });
    });

    this.dictSrv.getRemoteData('risklevel').then((result: IDictItemType[]) => {
      this.levelsDict = result.map((item) => {
        return {id: item.code, name: item.name};
      });
    });

    this.dictSrv.getRemoteData('oksm').then((result: IDictCountryItemType[]) => {
      this.oksmDict = result;
      this.initModelCountry();
    });

    this.dictSrv.getRemoteData('okved').then((result: IDictItemType[]) => {
      this.okvedDict = (result || []).sort((item1: IDictItemType, item2: IDictItemType) => {
        return item1.code.toLowerCase() > item2.code.toLowerCase() ? 1 : -1;
      });
      this.initModelOkved();
    });

    this.dictSrv.getRemoteData('okved2').then((result: IDictItemType[]) => {
      this.okved2Dict = (result || []).sort((item1: IDictItemType, item2: IDictItemType) => {
        return item1.code.toLowerCase() > item2.code.toLowerCase() ? 1 : -1;
      });
      this.initModelOkved2();
    });
  }

  /**
   * Инициализация формы
   */
  private _initForm(): void {
    this.formGroup = this.formBuilder.group({
      npa: null,
      cause: [null, this.validationSrv.getValidation({
        isReq: true
      })],
      type: ['1', this.validationSrv.getValidation({
        isReq: true
      })],
      level: [null, this.validationSrv.getValidation({
        isReq: true
      })],
      active: false,
      manualMode: false, // Ручной контроль
      deleted: false,
      comment: null,
      property: null,
      scoreDegree: null,
      scoreIncrease: null,
      scoreResult: null,
      classValidation: [null, this.validationSrv.getValidation({
        isReq: true
      })]
    });
  }

  private _checkAccessUser(): void {
    if (this.isReadOnlyAccess) {
      this.formGroup.disable();
    }
  }

  /**
   * Установка значения формы
   */
  private _setForm(): void {
    const data = this.route.snapshot.data.resolveData as RiskfactorInfo;
    if (data) {
      if (data.classId) {
        data.classValidation = data.classId.id;
        this.currentClassName = data.classId.className;
      }
      if (data.scoreDegree) {
        this.selectedDegree = data.scoreDegree.id;
      }
      if (data.scoreIncrease) {
        this.selectedIncrease = data.scoreIncrease.id;
      }
      if (data.scoreResult) {
        this.scoreResult = data.scoreResult;
      }
      this.formGroup.patchValue(data);

      this.subjects = this._getChangeSubjectsOrder(data);
      if (data.property) {
        this.property = JSON.parse(data.property);
      }
      if(this.isPdlClass()){
        this.initTypePdl();
      }
    }
  }

  private _getChangeSubjectsOrder(data: { subjects: RiskfactorSubject[] }): RiskfactorSubject[] {
    const copySubjects: RiskfactorSubject[] = Utils.clone(data.subjects);
    data.subjects[1] = copySubjects[3];
    data.subjects[2] = copySubjects[5];
    data.subjects[3] = copySubjects[1];
    data.subjects[5] = copySubjects[2];
    return data.subjects;
  }

  protected selectedClass(newClass: RiskfactorClasses) {
    this.currentClassName = newClass.className;
  }

  /**
   * Выбираем степень риска score_degree
   * при выборе меняется значения для справочника "Повышающий коэффициент"
   * @param e
  */
  selectScoreDegree(e, firstLoad?: boolean): void {
    const select = this.scoreDegree?.filter(item => item.id === e);
    if (select && !firstLoad) {
      this.scoreEncrease = select[0]?.scoreIncrease;
      if (e === 1 || e === 2 || e === 6) {
        this.selectedIncrease = 0;
        this.scoreResult = Number(this.scoreEncrease?.filter(item => item.id === this.selectedIncrease)[0].score);
        this.formGroup.controls['scoreIncrease'].disable();
      } else {
        const select = this.scoreEncrease?.filter(item => item.id === 0);
        this.selectedIncrease = 0;
        this.scoreResult = Number(select[0]?.score);
        this.formGroup.controls['scoreIncrease'].enable();
      }

    }
  }

  /**
   * Выбираем степень риска score_increase
   * при выборе меняется значения для справочника "Повышающий коэффициент"
   * @param e
  */
   selectScoreEncrease(e: number): void {
    setTimeout(() => {
      const select = this.scoreEncrease?.filter(item => item.id === e);
    if (select.length) {
      this.scoreResult = Number(select[0]?.score);
      this.formGroup.get('scoreResult').patchValue( this.scoreResult);
    }
    } , 0)
    }

  private initTypePdl() {
    const isRelative = this.isPdlRClass();
    const codes: any[] = this?.property?.condition.map(condition => {
      const code = condition["publicInfo.characterPDL.code"];
      return isRelative ? String(code - 1) : code;
    });
    this.pdlTypes.forEach(pdlType => {
      if(codes.includes(pdlType.code)){
        pdlType.checked = true;
      }
    });
  }
}

